module.exports = __webpack_public_path__ + "static/img/voice0_down.46b2be66.png";